import { useState } from "react"

import MultiSelectDropdown from "../../../MultiSelectDropdown/MultiSelectDropdown"
import InputTag from "../../../Input/InputTag"
import Table from "../../../Table/Table"
import SearchInputV2 from "../../../SearchInputV2/SearchInputV2"
import VirtualizedSearchSelect from "../../../VirtualizedSearchSelect"
import useMaterialDispatch from "./useMaterialDispatch"
import MuiAutoComplete from "../../../MuiAutocomplete"
import { FormPageProps } from "../.."
import { DropdownObj } from "../../../../pages/Common/commonTypes"

import upload from "../../../../assets/images/upload_icon.svg"
import data_loader from "../../../../assets/images/data_loader.gif"
import error_mark from "../../../../assets/images/error_mark.svg"
import "../../RaiseTicketFormBeta.scss"

const MaterialDispatch = ({ handleNextStep, handleCloseForm, isLastStep }: FormPageProps) => {
    const [showMaterialTable, setShowMaterialTable] = useState(false)

    const { states, functions } = useMaterialDispatch({ handleNextStep })

    return (
        <>
            <div className="d-flex flex-column gap-32 material_dispatch">
                <div className="section">
                    <div className="d-flex flex-column w-50">
                        <div className="section_header">Project Name*</div>
                        <InputTag
                            name="project_name"
                            type="text"
                            placeholder="Enter Project Name"
                            className="grey-blue text-xs w-250"
                            height="44px"
                            value={states.materialDispatchForm.values.project_name}
                            onChange={states.materialDispatchForm.handleChange}
                            error={!!states.materialDispatchForm.errors.project_name}
                            showError={states.materialDispatchForm.submitCount > 0}
                        />
                    </div>
                </div>
                <div className="section">
                    <div className="section_orange_header">REQUESTED DATE AND TIME OF DELIVERY</div>
                    <div className="d-flex gap-24 mt-24">
                        <div className="d-flex flex-column">
                            <div className="section_header">Visit By*</div>
                            <InputTag
                                name="visit_by_date"
                                type="date"
                                placeholder="Select a date"
                                useCustomDate
                                className="grey-blue text-xs w-250"
                                height="44px"
                                value={states.materialDispatchForm.values.visit_by_date}
                                onChange={states.materialDispatchForm.handleChange}
                                error={!!states.materialDispatchForm.errors.visit_by_date}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                        <div className="d-flex flex-column w-25">
                            <div className="section_header visibility-hidden">Time of day</div>
                            <MuiAutoComplete
                                sx={{
                                    height: "44px !important",
                                }}
                                placeholder="Select Time Of Day"
                                options={states.timeOfDayOptions || []}
                                value={
                                    states.materialDispatchForm.values.visit_by_time?.id
                                        ? states.materialDispatchForm.values.visit_by_time
                                        : null
                                }
                                onChange={(value: any) => {
                                    states.materialDispatchForm.setFieldValue("visit_by_time", value)
                                }}
                                error={
                                    !!states.materialDispatchForm.errors.visit_by_time &&
                                    states.materialDispatchForm.submitCount > 0
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="section_orange_header">POC Details</div>
                    <div className="d-flex flex-column my-24">
                        <div className="section_header">Source Site*</div>
                        <VirtualizedSearchSelect
                            height="44px"
                            className="w-50"
                            fontSize="10px"
                            placeholder="Select Site"
                            options={states.siteOptions}
                            loading={states.isSitesLoading}
                            onSearch={functions.handleSearchSites}
                            onLoadMore={functions.handleLoadMoreSites}
                            onChange={(value: DropdownObj) => {
                                functions.handleSiteChange(value)
                            }}
                            error={states.materialDispatchForm.errors.source_site_id?.title}
                            showError={states.materialDispatchForm.submitCount > 0}
                        />
                    </div>
                    <div className="d-flex gap-24">
                        <div className="d-flex flex-column w-50">
                            <div className="section_header">Source Address*</div>
                            <InputTag
                                type="text"
                                placeholder="Enter Source Address"
                                className="w-100 grey-blue text-xs"
                                height="44px"
                                value={states.materialDispatchForm.values.source_address}
                                error={!!states.materialDispatchForm.errors.source_address}
                                showError={states.materialDispatchForm.submitCount > 0}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="d-flex gap-24 mt-16">
                        <div className="d-flex flex-column flex-1">
                            <div className="section_header">Pincode*</div>
                            <InputTag
                                type="text"
                                placeholder="Enter Pincode"
                                height="44px"
                                className="grey-blue text-xs"
                                value={states.materialDispatchForm.values.source_pincode}
                                error={!!states.materialDispatchForm.errors.source_pincode}
                                showError={states.materialDispatchForm.submitCount > 0}
                                disabled
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <div className="section_header">State*</div>
                            <MultiSelectDropdown
                                fontsize="10px"
                                title="Select State"
                                options={states.stateList?.map(i => ({
                                    title: i.name,
                                    id: i.id,
                                }))}
                                selectStyle={{
                                    color: "#70758D",
                                    opacity: 1,
                                }}
                                id="sow_template"
                                onChange={() => {}}
                                selectedOptions={[states.materialDispatchForm.values.source_state]}
                                selectionType={"single"}
                                height="44px"
                                error={!!states.materialDispatchForm.errors.source_state}
                                showError={states.materialDispatchForm.submitCount > 0}
                                disabled={true}
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <div className="section_header">City*</div>
                            <MultiSelectDropdown
                                fontsize="10px"
                                title="Select City"
                                options={states.cityList?.map(i => ({
                                    title: i.name,
                                    id: i.id,
                                }))}
                                selectStyle={{
                                    color: "#70758D",
                                    opacity: 1,
                                }}
                                id="sow_template"
                                onChange={() => {}}
                                selectedOptions={[states.materialDispatchForm.values.source_city]}
                                selectionType={"single"}
                                height="44px"
                                error={!!states.materialDispatchForm.errors.source_city}
                                showError={states.materialDispatchForm.submitCount > 0}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-16 mb-10">
                        <div className="section_header mb-0">SOURCE POC*</div>
                        {/* <label className="text-xs d-flex align-items-center">
                            <input type="checkbox" className="mr-6 mb-3" />
                            Same as Account Contact
                        </label> */}
                    </div>
                    <div className="d-flex gap-24">
                        <div className="d-flex flex-column flex-1">
                            <InputTag
                                type="text"
                                name="source_poc.name"
                                placeholder="Enter Name"
                                height="44px"
                                className="grey-blue text-xs"
                                onChange={states.materialDispatchForm.handleChange}
                                value={states.materialDispatchForm.values.source_poc?.name}
                                error={!!states.materialDispatchForm.errors.source_poc?.name}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <SearchInputV2
                                type="number"
                                placeholder="Enter Phone"
                                maxCharacter={10}
                                height="44px"
                                onSearch={(value: string) =>
                                    states.materialDispatchForm.setFieldValue("source_poc.phone", value)
                                }
                                containerClass="grey-blue text-xs"
                                value={states.materialDispatchForm.values.source_poc?.phone}
                                error={!!states.materialDispatchForm.errors.source_poc?.phone}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <InputTag
                                type="text"
                                placeholder="Enter Email"
                                name="source_poc.email"
                                height="44px"
                                className="grey-blue text-xs"
                                onChange={states.materialDispatchForm.handleChange}
                                value={states.materialDispatchForm.values.source_poc?.email}
                                error={!!states.materialDispatchForm.errors.source_poc?.email}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-16 mb-10">
                        <div className="section_header mb-0">DESTINATION POC*</div>
                    </div>
                    <div className="d-flex gap-24">
                        <div className="d-flex flex-column flex-1">
                            <InputTag
                                type="text"
                                name="destination_poc.name"
                                placeholder="Enter Name"
                                height="44px"
                                className="grey-blue text-xs"
                                onChange={states.materialDispatchForm.handleChange}
                                value={states.materialDispatchForm.values.destination_poc?.name}
                                error={!!states.materialDispatchForm.errors.destination_poc?.name}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <SearchInputV2
                                type="number"
                                placeholder="Enter Phone"
                                maxCharacter={10}
                                height="44px"
                                onSearch={(value: string) =>
                                    states.materialDispatchForm.setFieldValue("destination_poc.phone", value)
                                }
                                containerClass="grey-blue text-xs"
                                value={states.materialDispatchForm.values.destination_poc?.phone}
                                error={!!states.materialDispatchForm.errors.destination_poc?.phone}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                        <div className="d-flex flex-column flex-1">
                            <InputTag
                                type="text"
                                name="destination_poc.email"
                                placeholder="Enter Email"
                                height="44px"
                                className="grey-blue text-xs"
                                onChange={states.materialDispatchForm.handleChange}
                                value={states.materialDispatchForm.values.destination_poc?.email}
                                error={!!states.materialDispatchForm.errors.destination_poc?.email}
                                showError={states.materialDispatchForm.submitCount > 0}
                            />
                        </div>
                    </div>
                </div>

                <div className="section">
                    <div className="section_orange_header">MATERIAL DETAILS</div>
                    <div
                        className="charger_file_input_container mt-24"
                        style={{
                            width: states.deviceType === "Desktop" ? "590px" : "100%",
                            border: "1px dashed #101941",
                        }}
                    >
                        {states.isUploadingDr ? (
                            <img src={data_loader} height={100} width={100} alt="Loading..." />
                        ) : (
                            <>
                                <div>
                                    <img src={upload} alt="upload" />
                                </div>
                                <label className="text-xs">
                                    Drag and Drop file here or <span className="subtext">upload file</span>
                                </label>
                                <input
                                    accept=".xlsx, .xls, .csv, .xlsm, .xlsb, .xltx, .xltm"
                                    onChange={e => {
                                        functions.handleFileUpload(e)
                                    }}
                                    type="file"
                                    title=""
                                    style={{
                                        border: "1px dashed #101941",
                                    }}
                                />
                            </>
                        )}
                    </div>
                    {Boolean(states.materialDispatchForm.values.file) && (
                        <div
                            className="text-xxs error_message weight-500 text-right"
                            style={{
                                width: states.deviceType === "Desktop" ? "590px" : "100%",
                            }}
                        >
                            1 file uploaded
                        </div>
                    )}
                    <div></div>
                    <div className="download_excel mt-24">
                        <a href={states.gsrTemplate?.urls.download || ""} rel="noreferrer" target="_blank">
                            Download Excel Template
                        </a>
                    </div>
                </div>

                <div className="section">
                    <div className="section_orange_header d-flex justify-content-between mb-24 align-items-center">
                        <div className="d-flex align-items-center">
                            MATERIAL (
                            {(states.materialDispatchForm.values.materials?.length || 0).toString().padStart(2, "0")})
                            {states.materialDispatchForm.submitCount > 0 &&
                                states.materialDispatchForm.values.materials?.length === 0 && (
                                    <img src={error_mark} alt="" className="pl-4" />
                                )}
                        </div>
                        <div className="text-xxs expand_btn" onClick={() => setShowMaterialTable(!showMaterialTable)}>
                            {showMaterialTable ? "See Less" : "See More"}
                        </div>
                    </div>
                    {showMaterialTable && (
                        <>
                            <Table
                                headerData={states.materialTableHeaders}
                                rowData={states.materialRowData}
                                loading={false}
                                maxHeight="500px"
                                zIndex={1}
                            />
                            <div className="d-flex justify-content-center">
                                <div
                                    className="add_new_btn text-sm weight-500 mt-24 cursor-pointer"
                                    onClick={functions.handleAddMaterialRow}
                                >
                                    Add New
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <footer className="raise-ticket-form__footer">
                <button className="raise-ticket-form__footer-button cancel-btn" onClick={handleCloseForm}>
                    Cancel
                </button>
                <button
                    className="raise-ticket-form__footer-button next-btn"
                    disabled={states.isRaisingSoloLogistics}
                    onClick={() => states.materialDispatchForm.handleSubmit()}
                >
                    {isLastStep ? "Submit" : "Next"}
                </button>
            </footer>
        </>
    )
}

export default MaterialDispatch
